/*
  離脱防止バナー用
*/
const DISPLAY_DELAY_MS = 20000

document.addEventListener('DOMContentLoaded', () => {
  const bannerElement = document.querySelector('.dp-modal-wrap')
  const closeButtonElement = document.querySelector('.dp-modal-close')
  const layerElement = document.querySelector('.dp-modal-layer')

  if (!bannerElement || !closeButtonElement || !layerElement) return
  if (sessionStorage.getItem('BannerDisplayStatus') === 'done') return

  setTimeout(showBanner, DISPLAY_DELAY_MS)

  closeButtonElement.addEventListener('click', hideBanner)
  layerElement.addEventListener('click', hideBanner)

  function showBanner () {
    bannerElement.style.display = 'block'
    sessionStorage.setItem('BannerDisplayStatus', 'done')
  }

  function hideBanner () {
    bannerElement.style.display = 'none'
  }
})
